<template>
  <div>
    <slot name="header" />
    <div class="mb-5">
      <div v-if="isFetchingUserLanguages" class="full-width">
        <v-skeleton-loader type="list-item" />
      </div>
      <div v-else>
        <v-chip
          class="mr-2"
          v-for="(language, index) in currentUserLanguages"
          :key="index"
        >
          {{ language.level }} {{ language.name }}
        </v-chip>
        <span v-if="isListEmpty"> - </span>
      </div>
    </div>
    <v-divider v-if="showDivider" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { copyState } from "@/utils/helpers";
import { FETCH_USER_LANGUAGES } from "@/store/modules/users/languagesAndSkills/actions";
import { LANGUAGES_AND_SKILLS_NAMESPACE } from "@/store/modules/users/languagesAndSkills";
import { isEmpty } from "lodash";

const { mapActions, mapState } = createNamespacedHelpers(
  LANGUAGES_AND_SKILLS_NAMESPACE
);

export default {
  name: "LanguageList",
  props: {
    userId: {
      type: String,
      required: true
    },
    showDivider: Boolean
  },
  created() {
    this.fetchUserLanguages(this.userId);
  },
  computed: {
    ...mapState(copyState(["isFetchingUserLanguages", "currentUserLanguages"])),
    isListEmpty() {
      return isEmpty(this.currentUserLanguages);
    }
  },
  methods: {
    ...mapActions({
      fetchUserLanguages: FETCH_USER_LANGUAGES
    })
  }
};
</script>
